import React from 'react';
import { Icon, Tooltip, Typography } from 'antd';
import moment from 'moment';
import EllipsisTextWithTooltip from '../../../../../../../../components/EllipsisTextWithTooltip/EllipsisTextWithTooltip';
import styles from './index.module.scss';

const AttachmentChildren = ({ attachment, parent }) => {
  if (parent === 'actions') {
    return <ActionsChildren attachment={attachment} />;
  }

  if (parent === 'card') {
    return <CardChildren attachment={attachment} />;
  }

  return null;
};

export default AttachmentChildren;

function CardChildren({ attachment }) {
  const { fromDate, toDate, description, availableForClient } = attachment;

  if (!description && !availableForClient) {
    return null;
  }

  return (
    <div className={styles.root}>
      {description && (
        <EllipsisTextWithTooltip tooltipTitle={description}>
          {description}
        </EllipsisTextWithTooltip>
      )}

      {availableForClient && (
        <div className={styles.periodWrapper}>
          <Tooltip title="Показывается собственнику">
            <Icon type="eye" className={styles.eyeIcon} />
          </Tooltip>

          {fromDate && (
            <Typography.Text>
              {toDate
                ? `${formatDate(fromDate)} - ${formatDate(toDate)}`
                : `с ${formatDate(fromDate)}`}
            </Typography.Text>
          )}
        </div>
      )}
    </div>
  );
}

function ActionsChildren({ attachment }) {
  if (attachment.availableForClient) {
    return null;
  }

  return (
    <Tooltip title="Не показывается собственнику" placement="bottomRight">
      <Icon type="eye-invisible" className={styles.eyeIcon} />
    </Tooltip>
  );
}

function formatDate(date) {
  return moment(date).format('DD.MM.YYYY');
}
